var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"parking"}},[_c('p',[_vm._v(_vm._s(_vm.name))]),_vm._l((_vm.eventToday),function(event){return _c('div',{staticClass:"parking__avatar-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.userName(event))+": "+_vm._s(_vm.title(event)))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }